import { render, staticRenderFns } from "./AuthorizationForms.vue?vue&type=template&id=3601a0ef"
import script from "./AuthorizationForms.vue?vue&type=script&lang=js"
export * from "./AuthorizationForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports